import React from "react";
import PropTypes from "prop-types";
import { UserX } from "lucide-react";

import { UIEmptyState } from "../../../../ui";
import { PAYROLL_EMPTY_STATE_VARIANTS } from "../constants";

import "./_EventPayrollEmptyState.scss";

const EventPayrollEmptyState = ({ variant, labels }) => {
  const content =
    labels.emptyStates?.[variant] || labels.emptyStates?.event || {};

  return (
    <UIEmptyState
      title={content.title}
      description={content.description}
      icon={<UserX size={40} strokeWidth={1.5} />}
      classNames={{
        root: "event-payroll__empty",
        description: "event-payroll__empty-description",
        iconCircle: "event-payroll__empty-icon-circle",
      }}
    />
  );
};

EventPayrollEmptyState.propTypes = {
  variant: PropTypes.oneOf(Object.values(PAYROLL_EMPTY_STATE_VARIANTS)),
  labels: PropTypes.shape({
    emptyStates: PropTypes.shape({
      event: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
      filtered: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }).isRequired,
};

EventPayrollEmptyState.defaultProps = {
  variant: PAYROLL_EMPTY_STATE_VARIANTS.event,
};

export default EventPayrollEmptyState;
